webpackJsonp([160563707051050],{

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhoneNumbers = function PhoneNumbers(_ref) {
	  var phoneNumbers = _ref.phoneNumbers;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "margin-top-40" },
	    _react2.default.createElement(
	      "ul",
	      { className: "list simple" },
	      phoneNumbers.map(function (item) {
	        return _react2.default.createElement(
	          "li",
	          { key: item.name, className: "margin-top-10" },
	          _react2.default.createElement(
	            "span",
	            null,
	            item.name,
	            ":"
	          ),
	          item.number
	        );
	      })
	    )
	  );
	};
	
	exports.default = PhoneNumbers;
	module.exports = exports["default"];

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _PhoneNumbers = __webpack_require__(314);
	
	var _PhoneNumbers2 = _interopRequireDefault(_PhoneNumbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var activeLinkStyle = {
	  color: '#fff',
	  backgroundColor: '#1E69B8',
	  borderColor: '#1E69B8'
	};
	
	exports.default = function (props) {
	  var _props$data = props.data,
	      name = _props$data.name,
	      content1 = _props$data.content1,
	      content2 = _props$data.content2,
	      list = _props$data.list,
	      link = _props$data.link,
	      phoneNumbers = _props$data.phoneNumbers;
	  var image1 = props.image1,
	      image2 = props.image2;
	
	  var phoneNumbersComponent = phoneNumbers ? _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: 'box-header margin-top-40' },
	      'Numery kontaktowe'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'column-1-2' },
	      _react2.default.createElement(_PhoneNumbers2.default, { phoneNumbers: phoneNumbers })
	    )
	  ) : ' ';
	  return _react2.default.createElement(
	    'div',
	    { className: 'theme-page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row gray full-width page-header vertical-align-table' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row full-width padding-top-bottom-50 vertical-align-cell' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-header-left' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-header-right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bread-crumb-container' },
	              _react2.default.createElement(
	                'label',
	                null,
	                'JESTE\u015A TUTAJ:'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'bread-crumb' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/' },
	                    'STRONA G\u0141\xD3WNA'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'separator' },
	                  '/'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/uslugi' },
	                    'US\u0141UGI'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'separator' },
	                  '/'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  name
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'clearfix' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row margin-top-70' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-1-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'vertical-menu' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/mechanika', activeStyle: activeLinkStyle, title: 'Mechanika' },
	                'MECHANIKA',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/uslugi/diagnostyka',
	                  activeStyle: activeLinkStyle,
	                  title: 'Diagnostyka / Kodowanie / Doposa\u017Canie pojazdu'
	                },
	                'DIAGNOSTYKA',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/naprawy-powypadkowe', activeStyle: activeLinkStyle, title: 'Naprawy powypadkowe' },
	                'NAPRAWY POWYPADKOWE',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/czesci-nowe-i-uzywane', activeStyle: activeLinkStyle, title: 'Cz\u0119\u015Bci nowe i u\u017Cywane' },
	                'CZ\u0118\u015ACI NOWE I U\u017BYWANE',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/motocykle', activeStyle: activeLinkStyle, title: 'Motocykle' },
	                'MOTOCYKLE',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/uslugi/profesjonalny-serwis-ogumienia',
	                  activeStyle: activeLinkStyle,
	                  title: 'Profesjonalny serwis ogumienia'
	                },
	                'SERWIS OGUMIENIA',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi/pomoc-drogowa', activeStyle: activeLinkStyle, title: 'Pomoc drogowa' },
	                'POMOC DROGOWA',
	                _react2.default.createElement('span', { className: 'template-arrow-menu' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'call-to-action page-margin-top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hexagon small' },
	              _react2.default.createElement('div', { className: 'sl-small-car-fix' })
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'margin-top-58' },
	              'Potrzebujesz pomocy?'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'description' },
	              'Um\xF3w si\u0119 na wizyt\u0119 w naszym serwisie.'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/kontakt', title: 'Kontakt', className: 'more' },
	              'UM\xD3W SI\u0118'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column column-3-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column column-1-2' },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: image1,
	                imgStyle: { objectPosition: '0 0', maxHeight: '260px' },
	                style: { width: '100%', maxHeight: '260px' }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column column-1-2' },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: image2,
	                imgStyle: { objectPosition: '0 0', maxHeight: '260px' },
	                style: { width: '100%', maxHeight: '260px' }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row page-margin-top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column-1-1' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'box-header' },
	                'Opis us\u0142ugi'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'margin-top-20' },
	                content1
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                content2,
	                link ? _react2.default.createElement(
	                  'a',
	                  { href: link.url, className: 'reservation-link', target: '_blank' },
	                  link.title
	                ) : ''
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'box-header margin-top-26' },
	                'Jakie us\u0142ugi \u015Bwiadczymy?'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'list margin-top-30' },
	                list.map(function (item) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: item, className: 'template-bullet' },
	                    item
	                  );
	                })
	              ),
	              phoneNumbersComponent
	            )
	          ),
	          _react2.default.createElement('div', { className: 'row page-margin-top' })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Service = __webpack_require__(316);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _SEO = __webpack_require__(37);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SEO2.default, { siteData: data.page.siteData, isSEO: true }),
	    _react2.default.createElement(_Service2.default, { data: data.page, image1: data[data.page.image1].sizes, image2: data[data.page.image2].sizes })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-template-services-js-b963b74200877ccf3625.js